// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div class="box">

<print-header branch-id="\$ctrl.account.branchId" print-name="'Account details'"></print-header>

<div ng-if="\$ctrl.account">
    <table class="table">
        <tr>
            <td>Account branch:</td>
            <td>{{\$ctrl.account.branchName}}</td>
        </tr>
        <tr>
            <td>CIF No.:</td>
            <td>{{\$ctrl.profile.customerNumber}}</td>
        </tr>
        <tr>
            <td>CIF Name:</td>
            <td>{{\$ctrl.profile.effectiveName}}</td>
        </tr>
        <tr>
            <td>Address:</td>
            <td>{{(\$ctrl.profile.primaryAddress | prettyAddress) || '-'}}</td>
        </tr>
        <tr>
            <td colspan="2" class="separator"></td>
        </tr>
        <tr>
            <td>Account Number:</td>
            <td>{{\$ctrl.account.productNumber}}</td>
        </tr>
        <tr>
            <td>Account Name:</td>
            <td>{{\$ctrl.account.productName}}</td>
        </tr>
        <tr ng-if="\$ctrl.passbookSupported(\$ctrl.account.accountType)">
            <td>Passbook No.:</td>
            <td>{{\$ctrl.account.passbookNumber || '-'}}</td>
        </tr>
        <tr>
            <td colspan="2" class="separator"></td>
        </tr>
        <tr>
            <td>Status:</td>
            <td>{{\$ctrl.account.status}}</td>
        </tr>
        <tr>
            <td>Created on:</td>
            <td>{{\$ctrl.account.createdOn | prettyDate}}</td>
        </tr>
        <tr ng-if="\$ctrl.account.closedOn">
            <td>Closed on:</td>
            <td>{{\$ctrl.account.closedOn | prettyDate}}</td>
        </tr>
        <tr>
            <td colspan="2" class="separator"></td>
        </tr>
        <tr>
            <td>Last Transaction Date:</td>
            <td>{{(\$ctrl.account.lastCustomerTransaction | prettyDate) || '-'}}</td>
        </tr>
        <tr>
            <td>Interest Rate:</td>
            <td>{{\$ctrl.account.interestRange}}</td>
        </tr>
        <tr>
            <td>Accrued interest:</td>
            <td>{{\$ctrl.account.accruedInterest | nxCurrency}}</td>
        </tr>
        <tr>
            <td>Tax exempted:</td>
            <td>{{\$ctrl.account.taxExempted ? 'Yes' : 'No'}}</td>
        </tr>
        <tr>
            <td>Dormancy date:</td>
            <td>{{(\$ctrl.account.dormancyDate | prettyDate) || '-'}}</td>
        </tr>
        <tr>
            <td>Last interest application:</td>
            <td>{{(\$ctrl.account.lastInterestApplication | prettyDate) || '-'}}</td>
        </tr>
        <tr>
            <td>Last dormancy charge:</td>
            <td>{{(\$ctrl.account.lastDormancyCharge | prettyDate) || '-'}}</td>
        </tr>
        <tr>
            <td>Last maintaining charge:</td>
            <td>{{(\$ctrl.account.lastMaintainingCharge | prettyDate) || '-'}}</td>
        </tr>
        <tr>
            <td>Last accrual:</td>
            <td>{{(\$ctrl.account.lastAccrualDate | prettyDate) || '-'}}</td>
        </tr>
        <tr>
            <td colspan="2" class="separator"></td>
        </tr>
        <tr>
            <td>Casa class code:</td>
            <td>{{\$ctrl.account.casaClassCode}}</td>
        </tr>
        <tr>
            <td>Related People:</td>
            <td>
                <span class="value" ng-repeat="relative in \$ctrl.profile.relatives">
                    [ {{relative.customerNumber || '-'}} ][ {{relative.effectiveName}} ][ {{relative.relation}} ]{{\$last ? '' : ', '}}
                  </span>
                <span ng-if="!\$ctrl.profile.relatives">-</span>
            </td>
        </tr>
        <tr>
            <td colspan="2" class="separator"></td>
        </tr>
        <tr>
            <td>ADB Interest:</td>
            <td>{{\$ctrl.account.adbInterest | nxCurrency}}</td>
        </tr>
        <tr>
            <td>ADB Monthly:</td>
            <td>{{\$ctrl.account.adbMonthly | nxCurrency}}</td>
        </tr>
        <tr>
            <td>ADB Last 90 days:</td>
            <td>{{\$ctrl.account.adbLast90Days | nxCurrency}}</td>
        </tr>
        <tr>
            <td>Uncleared deposits:</td>
            <td>{{\$ctrl.account.totalUnclearedCheckDepositAmount | nxCurrency}}</td>
        </tr>
        <tr>
            <td>Available balance:</td>
            <td>{{\$ctrl.account.balance | nxCurrency}}</td>
        </tr>
        <tr>
            <td colspan="2" class="separator"></td>
        </tr>
        <tr>
            <td>Related accounts:</td>
            <td><span ng-repeat="account in \$ctrl.account.relatedAccounts">
                {{account.productNumber}}{{\$last ? '' : ', '}}</span>
                <span ng-if="!\$ctrl.account.relatedAccounts">-</span>
            </td>
        </tr>
    </table>

    <button type="button" class="btn btn-print pull-right" ng-click="\$ctrl.print()">Print</button>
</div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/details/customer-account-details-print.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;